// extracted by mini-css-extract-plugin
export default {"editorIFrame":"FramePortal_editorIFrame__Sx2Cw","noHeader":"FramePortal_noHeader__apu2H"};